<section id="news" [dir]="'Direction' | translate">
  <div class="empty-space"></div>
  <div class="jobs">
    <div class="container" data-aos="fade-up" data-aos-duration="1000">
      <div class="section-box">
        <div>
         <span class="section-title" >
            {{ 'News.Title' | translate }}
         </span>
        </div>
        <div class="jobs-inner" >
          <div class="news-container" data-aos="fade-up" data-aos-duration="1000">
            <ul ngbNav #nav="ngbNav" class="nav-tabs">
              <li *ngFor="let category of categories" ngbNavItem (click)="changeCategory(category)">
                <a ngbNavLink>{{ category }}</a>
              </li>
            </ul>

            <div *ngIf="!selectedArticle" class="news-list" data-aos="fade-up" data-aos-duration="1000">
              <div *ngFor="let article of displayedArticles" class="news-item" (click)="selectArticle(article)">
                <div class="news-image">
                  <img [src]="article.imagePath || 'assets/images/stocks.jpg'" alt="Article Image">
                </div>
                <div class="news-content">
                  <h3 class="news-title">{{ getHeader(article.newsHeader) }}</h3>
                  <p class="news-date">{{ dateFormatterService.getFormattedDate(article.newsDate) }}</p>
                  <p class="news-summary">{{ getSummary(article.newsDetails) }}</p>
                  <a (click)="selectArticle(article)" class="news-read-more">{{ 'News.ReadMore' | translate }}</a>
                </div>
              </div>
              <p *ngIf="displayedArticles.length === 0" class="news-empty">{{ 'News.NoNews' | translate }}</p>
              <div class="pagination" *ngIf="filteredArticles.length > 0">
                <button (click)="changePage(1)" [disabled]="currentPage === 1">{{ 'First' | translate }}</button>
                <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">&laquo;</button>
                <ng-container *ngFor="let page of getDisplayedPages()">
                  <button (click)="changePage(page)" [class.active]="page === currentPage">{{ page }}</button>
                </ng-container>
                <button (click)="changePage(currentPage + 1)" [disabled]="currentPage * pageSize >= filteredArticles.length">&raquo;</button>
                <button (click)="changePage(totalPages)" [disabled]="currentPage === totalPages">{{ 'Last' | translate }}</button>
              </div>
            </div>

            <div *ngIf="selectedArticle" class="news-detail-container" [@fadeInAnimation]>
              <div class="back-button" (click)="clearSelection()">{{ 'News.Back' | translate }}</div>
              <div class="news-detail-image" [@imageAnimation]>
                <img [src]="selectedArticle.imagePath || 'assets/images/stocks.jpg'" alt="Article Image">
              </div>
              <div class="news-detail-content">
                <h1 class="news-detail-title">{{ selectedArticle.newsHeader }}</h1>
                <p class="news-detail-date">{{ selectedArticle.newsDate | date:'fullDate' }}</p>
                <p class="news-detail-summary" [innerHTML]="getSafeHtml(selectedArticle.newsDetails)"></p>
              </div>
              <div *ngIf="selectedArticle.newsAttachment">
                <a [href]="selectedArticle.newsAttachment" target="_blank" rel="noopener noreferrer" class="download-button">
                  {{ 'News.DownloadAttachment' | translate }}
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
